export type OrgListQueryFilters = {
  tier?: number;
  rankingType?: string;
  reviewStatus?: string;
  search?: string;
};

/** The URL params the org list owns. Anything else in the address is left alone. */
export const ORG_LIST_FILTER_PARAMS = ["tier", "rankingType", "reviewStatus", "search"] as const;

/** Reads the org list's four filters out of the URL, omitting any that are absent. */
export function readOrgListFilters(params: URLSearchParams): OrgListQueryFilters {
  const filters: OrgListQueryFilters = {};

  const tierParam = params.get("tier");
  if (tierParam !== null && tierParam !== "") {
    const tier = Number(tierParam);
    if (!Number.isNaN(tier)) {
      filters.tier = tier;
    }
  }

  const rankingType = params.get("rankingType");
  if (rankingType !== null) {
    filters.rankingType = rankingType;
  }

  const reviewStatus = params.get("reviewStatus");
  if (reviewStatus !== null && reviewStatus !== "all") {
    filters.reviewStatus = reviewStatus;
  }

  const search = params.get("search");
  if (search !== null) {
    filters.search = search;
  }

  return filters;
}

/** Writes the org list's four filters into a new URLSearchParams, leaving other params untouched. */
export function writeOrgListFilters(
  params: URLSearchParams,
  filters: OrgListQueryFilters,
): URLSearchParams {
  const next = new URLSearchParams(params);

  for (const key of ORG_LIST_FILTER_PARAMS) {
    const value = filters[key];
    if (value === undefined) {
      next.delete(key);
    } else {
      next.set(key, String(value));
    }
  }

  return next;
}
